module.exports = {
    CACHE_TTL: 12 * 60 * 60 * 1000, // 12 hours,
    ATC_INDEXED_LOCATION_FILTERS: 'atc-indexed-location-filters',
    KBB_INDEXED_LOCATION_FILTERS: 'kbb-indexed-location-filters',
    KBB_GLOBAL_NAV_CONFIGURATION: 'kbb-global-nav-configuration',
    FORD_INDEXED_LOCATION_FILTERS: 'ford-indexed-location-filters',
    INTEREST_RATES: 'interest-rates',
    KBB_DMA_CODES: 'kbb-dma-codes',
    LOCATION_PRIORITY_HIGH: 'high',
    LOCATION_PRIORITY_HIGHEST: 'highest',
    LOCATION_PRIORITY_ALL: 'all',
    MARKETS: 'markets',
    REFERENCE_API: 'bonnet-reference',
    SEARCH_OPTIONS: 'searchoptions',
    STATE_ABBREVIATIONS: 'state-abbreviations',
    WALLET_CONFIGURATION: 'wallet-configuration',
};
